import { useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";
import { LOGO_URL } from "../lib/api";
import { SidebarNav } from "./SidebarNav";

export default function AppLayout() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  if (user === null)
    return (
      <div className="flex h-screen items-center justify-center text-sm text-slate-500">
        Loading…
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  if (user.must_reset_password) return <Navigate to="/change-password" replace />;

  return (
    <div className="flex h-screen bg-white">
      <aside className="hidden w-60 shrink-0 border-r border-slate-200 bg-slate-50 md:block">
        <SidebarNav close={() => setOpen(false)} />
      </aside>
      {open && (
        <div className="fixed inset-0 z-40 md:hidden">
          <div className="absolute inset-0 bg-slate-900/40" onClick={() => setOpen(false)} />
          <aside className="absolute left-0 top-0 h-full w-64 border-r border-slate-200 bg-slate-50">
            <button className="absolute right-3 top-3 text-slate-500" onClick={() => setOpen(false)} data-testid="close-sidebar">
              <X size={18} />
            </button>
            <SidebarNav close={() => setOpen(false)} />
          </aside>
        </div>
      )}
      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex items-center gap-3 border-b border-slate-200 px-4 py-3 md:hidden">
          <button onClick={() => setOpen(true)} data-testid="open-sidebar" className="text-slate-700">
            <List size={22} />
          </button>
          <img src={LOGO_URL} alt="DCN" className="h-8 w-auto" />
          <span className="text-sm font-semibold">Order &amp; Dispatch Hub</span>
        </header>
        <main className="flex-1 overflow-y-auto p-4 md:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
